/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Rail_Progress_BodyInputs */

const en_platform_rail_progress_body = /** @type {(inputs: Platform_Rail_Progress_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lifts, weight and measurements on a chart your client sees too.`)
};

const pl_platform_rail_progress_body = /** @type {(inputs: Platform_Rail_Progress_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ciężary, waga i obwody na wykresie, który widzi też podopieczny.`)
};

/**
* | output |
* | --- |
* | "Lifts, weight and measurements on a chart your client sees too." |
*
* @param {Platform_Rail_Progress_BodyInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_rail_progress_body = /** @type {((inputs?: Platform_Rail_Progress_BodyInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Rail_Progress_BodyInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_rail_progress_body(inputs)
	return en_platform_rail_progress_body(inputs)
});